import { WebSocketReceiveMessage } from './web-socket-receive-message';

export class WebSocketReceiveReloadTagGroups extends WebSocketReceiveMessage {
  override payload: {
    DeletedTagGroupId?: string;
    DeletedTagIds?: string; // comma-joined per backend
  };

  getDeletedTagGroupId(): string | null {
    return this.payload?.DeletedTagGroupId ?? null;
  }

  getDeletedTagIds(): string[] {
    return (
      this.payload?.DeletedTagIds?.split(',')
        ?.map(id => id?.trim())
        ?.filterNulls() ?? []
    );
  }
}
